import React, { useState } from "react";
import QRCode from "react-qr-code";
import { backendErrorMessage, readJsonResponse } from "../apiDiagnostics";
import { API_URL, FRONTEND_URL } from "../config";
import PageShell from "../components/PageShell";

const templates = {
  klassenfruehstueck: {
    title: "Klassenfrühstück",
    items: [
      { name: "Brötchen", maxCount: 30 },
      { name: "Butter", maxCount: 2 },
      { name: "Marmelade", maxCount: 3 },
      { name: "Nutella", maxCount: 2 },
      { name: "Honig", maxCount: 2 },
      { name: "Frischkäse", maxCount: 2 },
      { name: "Käse", maxCount: 3 },
      { name: "Wurstaufschnitt", maxCount: 3 },
      { name: "Müsli", maxCount: 3 },
      { name: "Joghurt", maxCount: 4 },
      { name: "Obst", maxCount: 4 },
      { name: "Gemüsesticks", maxCount: 3 },
      { name: "Milch", maxCount: 3 },
      { name: "Kakao", maxCount: 2 },
      { name: "Saft", maxCount: 4 },
      { name: "Teller", maxCount: 2 },
      { name: "Becher", maxCount: 2 },
      { name: "Besteck", maxCount: 2 },
      { name: "Servietten", maxCount: 2 }
    ]
  },
  grillen: {
    title: "Grillen",
    items: [
      { name: "Grillwürstchen", maxCount: 20 },
      { name: "Vegetarisches Grillgut", maxCount: 6 },
      { name: "Brötchen", maxCount: 20 },
      { name: "Ketchup", maxCount: 2 },
      { name: "Senf", maxCount: 2 },
      { name: "Grillsoßen", maxCount: 3 },
      { name: "Salat", maxCount: 4 },
      { name: "Nudelsalat", maxCount: 3 },
      { name: "Kartoffelsalat", maxCount: 3 },
      { name: "Rohkost", maxCount: 3 },
      { name: "Obst", maxCount: 3 },
      { name: "Getränke", maxCount: 6 },
      { name: "Grillkohle", maxCount: 2 },
      { name: "Grillzange", maxCount: 2 },
      { name: "Pappteller", maxCount: 2 },
      { name: "Becher", maxCount: 2 },
      { name: "Besteck", maxCount: 2 },
      { name: "Servietten", maxCount: 2 }
    ]
  },
  waffelessen: {
    title: "Waffelessen",
    items: [
      { name: "Waffelteig", maxCount: 5 },
      { name: "Waffeleisen", maxCount: 3 },
      { name: "Puderzucker", maxCount: 2 },
      { name: "Nutella", maxCount: 2 },
      { name: "Kirschen", maxCount: 3 },
      { name: "Sahne", maxCount: 3 },
      { name: "Apfelmus", maxCount: 3 },
      { name: "Vanilleeis", maxCount: 3 },
      { name: "Schokostreusel", maxCount: 2 },
      { name: "Bunte Streusel", maxCount: 2 },
      { name: "Bananen", maxCount: 3 },
      { name: "Erdbeeren", maxCount: 3 },
      { name: "Teller", maxCount: 2 },
      { name: "Besteck", maxCount: 2 },
      { name: "Servietten", maxCount: 2 }
    ]
  },
  weihnachtsfeier: {
    title: "Weihnachtsfeier",
    items: [
      { name: "Plätzchen", maxCount: 6 },
      { name: "Mandarinen", maxCount: 4 },
      { name: "Kinderpunsch", maxCount: 4 },
      { name: "Lebkuchen", maxCount: 4 },
      { name: "Nüsse", maxCount: 3 },
      { name: "Spekulatius", maxCount: 3 },
      { name: "Stollen", maxCount: 2 },
      { name: "Schokolade", maxCount: 3 },
      { name: "Zimtsterne", maxCount: 3 },
      { name: "Tee", maxCount: 2 },
      { name: "Becher", maxCount: 2 },
      { name: "Teller", maxCount: 2 },
      { name: "Weihnachtsmusik", maxCount: 1 },
      { name: "Lichterkette", maxCount: 1 },
      { name: "Servietten", maxCount: 2 }
    ]
  },
  lehrerfruehstueck: {
    title: "Lehrerfrühstück ;-)",
    items: [
      { name: "Champagner (Blanc de Blancs)", maxCount: 2 },
      { name: "Frisch gepresster Yuzu- oder Blutorangensaft", maxCount: 3 },
      { name: "Earl Grey (Loseblatt)", maxCount: 2 },
      { name: "Gänsestopfleber (Foie Gras)", maxCount: 1 },
      { name: "Hummer oder Languste", maxCount: 3 },
      { name: "Wagyu-Aufschnitt", maxCount: 2 },
      { name: "Kaviar", maxCount: 2 },
      { name: "Brioche oder Croissants", maxCount: 4 },
      { name: "Blinis", maxCount: 3 },
      { name: "Trüffelbutter", maxCount: 2 },
      { name: "Burrata", maxCount: 2 },
      { name: "Brie de Meaux", maxCount: 2 },
      { name: "Comté", maxCount: 2 },
      { name: "Frische Feigen", maxCount: 3 },
      { name: "Mangostreifen", maxCount: 3 },
      { name: "Handgemachte Pralinen oder Petit Fours", maxCount: 3 }
    ]
  }
};

function TeacherPage() {
  const [title, setTitle] = useState("");
  const [items, setItems] = useState([{ name: "", maxCount: 1 }]);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [showNames, setShowNames] = useState(true);
  const [allowParticipantItems, setAllowParticipantItems] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [isCreating, setIsCreating] = useState(false);

  function addItem() {
    setItems([...items, { name: "", maxCount: 1 }]);
  }

  function removeItem(index) {
    setItems(items.filter((_, i) => i !== index));
  }

  function updateItem(index, field, value) {
    const copy = [...items];
    copy[index][field] = value;
    setItems(copy);
  }

  function applyTemplate(templateKey) {
    setSelectedTemplate(templateKey);

    if (!templateKey) {
      setTitle("");
      setItems([{ name: "", maxCount: 1 }]);
      return;
    }

    const template = templates[templateKey];
    setTitle(template.title);
    setItems(template.items.map(item => ({ ...item })));
  }

  async function createList() {
    if (isCreating) return;

    setError("");
    setResult(null);

    const cleanItems = items
      .filter(item => item.name.trim() !== "")
      .map(item => ({
        name: item.name.trim(),
        maxCount: Math.max(1, Number(item.maxCount || 1))
      }));

    if (!title.trim()) return setError("Bitte geben Sie einen Namen für die Liste ein.");
    if (cleanItems.length === 0) return setError("Bitte fügen Sie mindestens einen Eintrag hinzu.");

    const url = `${API_URL}/api/lists`;
    setIsCreating(true);

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          title: title.trim(),
          items: cleanItems,
          listType: "normal",
          singleChoice: false,
          showNames,
          allowParticipantItems
        })
      });

      const data = await readJsonResponse(response, "Liste erstellen", url);
      if (!response.ok) return setError(data.error || "Liste konnte nicht erstellt werden.");
      setResult(data);
    } catch (err) {
      setError(backendErrorMessage("Liste erstellen", url, err));
    } finally {
      setIsCreating(false);
    }
  }

  const studentUrl = result ? FRONTEND_URL + result.studentLink : "";
  const teacherUrl = result ? FRONTEND_URL + result.teacherLink : "";
  const displayTitle = title.trim() || "Neue Mitbringliste";

  function printFlyer() {
    window.print();
  }

  return (
    <PageShell maxWidth="max-w-3xl">
      <header className="mb-8 print:hidden">
        <p className="mb-3 text-xs font-medium uppercase tracking-[0.22em] text-neutral-500">Lehrerbereich</p>
        <h1 className="text-4xl font-semibold tracking-[-0.04em]">{displayTitle}</h1>
        <p className="mt-3 text-base text-neutral-600">
          Erstellen Sie eine Liste und teilen Sie anschließend den Link oder QR-Code mit der Klasse.
        </p>
      </header>

      <section className="mb-5 rounded-2xl border border-[#dce8c8] bg-white p-5 shadow-sm print:hidden">
        <label className="mb-2 block text-sm font-medium text-neutral-700">Vorlage</label>
        <select
          className="mb-4 w-full rounded-xl border-[#c9d9b4] px-4 py-3 text-base focus:border-[#6d8f36] focus:ring-[#6d8f36]"
          value={selectedTemplate}
          onChange={e => applyTemplate(e.target.value)}
        >
          <option value="">Ohne Vorlage starten</option>
          <option value="klassenfruehstueck">Klassenfrühstück</option>
          <option value="grillen">Grillen</option>
          <option value="waffelessen">Waffelessen</option>
          <option value="weihnachtsfeier">Weihnachtsfeier</option>
          <option value="lehrerfruehstueck">Lehrerfrühstück ;-)</option>
        </select>

        <label className="mb-2 block text-sm font-medium text-neutral-700">Name der Liste</label>
        <input
          className="w-full rounded-xl border-[#c9d9b4] px-4 py-3 text-base focus:border-[#6d8f36] focus:ring-[#6d8f36]"
          placeholder="z.B. Klassenfrühstück 8b"
          value={title}
          onChange={e => setTitle(e.target.value)}
        />
      </section>

      <section className="mb-5 rounded-2xl border border-[#dce8c8] bg-white p-5 shadow-sm print:hidden">
        <div className="mb-4">
          <h2 className="text-xl font-semibold tracking-[-0.02em]">Zusatzfunktionen</h2>
          <p className="mt-1 text-sm text-neutral-500">Bestimme, wie Teilnehmerinnen und Teilnehmer mit der Liste arbeiten.</p>
        </div>

        <label className="flex items-start gap-3 rounded-xl border border-[#dce8c8] bg-[#f8faf2] p-4">
          <input
            className="mt-1 rounded border-[#c9d9b4] text-[#39501f] focus:ring-[#6d8f36]"
            type="checkbox"
            checked={showNames}
            onChange={e => setShowNames(e.target.checked)}
          />
          <span>
            <span className="block text-sm font-semibold text-neutral-800">Namen der Teilnehmer anzeigen</span>
            <span className="mt-1 block text-sm text-neutral-500">Wenn ausgeschaltet, sehen Teilnehmer nur belegte Mengen ohne fremde Namen.</span>
          </span>
        </label>

        <label className="mt-3 flex items-start gap-3 rounded-xl border border-[#dce8c8] bg-[#f8faf2] p-4">
          <input
            className="mt-1 rounded border-[#c9d9b4] text-[#39501f] focus:ring-[#6d8f36]"
            type="checkbox"
            checked={allowParticipantItems}
            onChange={e => setAllowParticipantItems(e.target.checked)}
          />
          <span>
            <span className="block text-sm font-semibold text-neutral-800">Teilnehmer dürfen Einträge ergänzen</span>
            <span className="mt-1 block text-sm text-neutral-500">Wenn aktiviert, kann die Liste von der Teilnehmerseite aus erweitert werden.</span>
          </span>
        </label>
      </section>

      <section className="mb-5 rounded-2xl border border-[#dce8c8] bg-white p-5 shadow-sm print:hidden">
        <div className="mb-4">
          <h2 className="text-xl font-semibold tracking-[-0.02em]">Mitbringliste</h2>
          <p className="mt-1 text-sm text-neutral-500">Lege fest, was mitgebracht werden soll und wie oft.</p>
        </div>

        <div className="space-y-3">
          {items.map((item, index) => (
            <div key={index} className="grid gap-3 rounded-xl border border-[#dce8c8] bg-[#f8faf2] p-3 sm:grid-cols-[1fr_100px_auto]">
              <input
                className="rounded-xl border-[#c9d9b4] px-4 py-2.5 text-sm focus:border-[#6d8f36] focus:ring-[#6d8f36]"
                placeholder="z.B. Brötchen"
                value={item.name}
                onChange={e => updateItem(index, "name", e.target.value)}
              />
              <input
                aria-label="Anzahl"
                className="rounded-xl border-[#c9d9b4] px-3 py-2.5 text-center text-sm focus:border-[#6d8f36] focus:ring-[#6d8f36]"
                type="number"
                min="1"
                title="Anzahl"
                value={item.maxCount}
                onChange={e => updateItem(index, "maxCount", e.target.value)}
              />
              <button type="button" onClick={() => removeItem(index)} className="rounded-xl bg-white px-3 py-2.5 text-sm font-medium text-neutral-500 hover:text-red-700">
                Entfernen
              </button>
            </div>
          ))}
        </div>

        <button type="button" onClick={addItem} className="mt-3 w-full rounded-xl border border-[#c9d9b4] bg-[#eef5df] px-3 py-2.5 text-sm font-semibold text-[#39501f] hover:bg-[#e0edc8]">
          + Eintrag
        </button>

        {error && <div className="mt-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-medium text-red-700">{error}</div>}

        <button
          type="button"
          onClick={createList}
          disabled={isCreating}
          className="mt-5 w-full rounded-xl bg-[#172017] px-4 py-3 text-sm font-semibold text-white shadow-sm hover:bg-[#263826] disabled:cursor-not-allowed disabled:opacity-70"
        >
          {isCreating ? "Liste wird erstellt..." : "Liste erstellen"}
        </button>
      </section>

      {result && (
        <section className="rounded-2xl border border-[#dce8c8] bg-white p-5 shadow-sm print:hidden">
          <h2 className="text-xl font-semibold tracking-[-0.02em]">Liste erstellt</h2>
          <p className="mt-2 text-sm text-neutral-500">Teilen Sie den Schülerlink oder zeigen Sie den QR-Code.</p>

          <div className="mt-5">
            <label className="mb-2 block text-sm font-medium text-neutral-700">Schülerlink</label>
            <input className="w-full rounded-xl border-[#c9d9b4] px-4 py-3 text-sm focus:border-[#6d8f36] focus:ring-[#6d8f36]" readOnly value={studentUrl} />
          </div>

          <div className="mt-5 rounded-2xl border border-[#dce8c8] bg-[#f8faf2] p-5">
            <p className="mb-4 text-center text-sm font-medium text-neutral-700">QR-Code für Schüler</p>
            <div className="mx-auto flex w-fit rounded-xl bg-white p-4">
              <QRCode value={studentUrl} size={190} />
            </div>
            <p className="mt-4 text-center text-sm text-neutral-500">Mit der Kamera scannen und direkt eintragen.</p>
            <button
              type="button"
              onClick={printFlyer}
              className="mt-5 w-full rounded-xl border border-[#c9d9b4] bg-white px-4 py-3 text-sm font-semibold text-[#39501f] hover:bg-[#eef5df]"
            >
              Flyer mit QR-Code drucken
            </button>
          </div>

          <div className="mt-5">
            <label className="mb-2 block text-sm font-medium text-neutral-700">Lehrerlink</label>
            <div className="mb-3 rounded-xl border-2 border-red-300 bg-red-50 px-4 py-3 text-base font-bold text-red-800">
              Wichtig: Speichern Sie diesen Lehrerlink sofort ab. Ohne diesen Link können Sie die Liste später nicht mehr verwalten, schließen, löschen oder als PDF speichern. Geben Sie ihn nicht an Schüler weiter.
            </div>
            <input className="w-full rounded-xl border-[#c9d9b4] px-4 py-3 text-sm focus:border-[#6d8f36] focus:ring-[#6d8f36]" readOnly value={teacherUrl} />
          </div>
        </section>
      )}

      {result && (
        <section className="hidden print:block">
          <div className="mx-auto flex min-h-[250mm] max-w-[190mm] flex-col items-center justify-center text-center">
            <h1 className="text-5xl font-semibold tracking-tight">{result.list?.title || displayTitle}</h1>
            <p className="mt-8 text-2xl text-neutral-700">Bitte scannen und direkt eintragen.</p>
            <div className="mt-10 rounded-2xl bg-white p-6">
              <QRCode value={studentUrl} size={320} />
            </div>
            <p className="mt-8 break-all text-lg text-neutral-600">{studentUrl}</p>
          </div>
        </section>
      )}
    </PageShell>
  );
}

export default TeacherPage;
